'use client';
import React from 'react';
import {
	FacebookShareButton,
	TwitterShareButton,
	WhatsappShareButton,
	LinkedinShareButton,
	EmailShareButton,
} from 'react-share';

type WrapperType = 'facebook' | 'twitter' | 'whatsapp' | 'linkedin' | 'email';

const componentsMap = {
	facebook: FacebookShareButton,
	twitter: TwitterShareButton,
	whatsapp: WhatsappShareButton,
	linkedin: LinkedinShareButton,
	email: EmailShareButton,
};

const platformLabels = {
	facebook: 'Share this trial on Facebook',
	twitter: 'Share this trial on Twitter',
	whatsapp: 'Share this trial on WhatsApp',
	linkedin: 'Share this trial on LinkedIn',
	email: 'Share this trial via Email',
};

export default function ShareSocial({
	wrapper,
	children,
	url,
	subject,
	body,
}: {
	wrapper: WrapperType;
	children: React.ReactNode;
	url: string;
	subject?: string;
	body?: string;
}) {
	const ShareComponent = componentsMap[wrapper];
	const ariaLabel = platformLabels[wrapper];

	if (!ShareComponent) return null;

	return (
		<ShareComponent
			url={url}
			subject={subject}
			body={body}
			aria-label={ariaLabel}
		>
			{children}
		</ShareComponent>
	);
}
